module.exports = __webpack_public_path__ + "static/media/Services.bc9c83a8.svg";